import { Button } from '../ui/button';
import { Wallet, Share2, Loader2 } from 'lucide-react';

export const BudgetBanner = ({
  generatedItinerary,
  currencyMode,
  convertedBudget,
  convertingCurrency,
  toggleCurrency,
  getNationalityCurrency,
  detectBudgetCurrency,
  trip_input,
  setShowShareBudgetDialog,
}) => {
  if (!generatedItinerary.estimated_total_budget) return null;

  const displayBudget = currencyMode === 'home' && convertedBudget
    ? convertedBudget
    : generatedItinerary.estimated_total_budget;

  return (
    <div className="mb-6 bg-white/95 backdrop-blur-xl border border-white/30 rounded-2xl p-4 shadow-xl" data-testid="budget-estimation-banner">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-serif text-base text-ocean flex items-center gap-2">
          <Wallet className="w-4 h-4 text-gold" />
          Estimated Trip Budget
        </h3>
        <div className="flex items-center gap-1.5">
          <Button
            variant="default"
            size="sm"
            onClick={toggleCurrency}
            disabled={convertingCurrency}
            className="text-[11px] bg-ocean hover:bg-ocean-light text-white h-7 px-3"
            data-testid="currency-toggle-btn"
          >
            {convertingCurrency ? (
              <Loader2 className="w-3 h-3 animate-spin mr-1" />
            ) : (
              <span className="mr-1">&#8644;</span>
            )}
            {currencyMode === 'destination'
              ? `Show in ${getNationalityCurrency(trip_input?.nationality)}`
              : `Show in ${detectBudgetCurrency()}`}
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowShareBudgetDialog(true)}
            className="text-[11px] border-gold/30 text-gold-dark hover:bg-gold/10 h-7 px-2"
            data-testid="share-budget-btn"
          >
            <Share2 className="w-3 h-3 mr-1" /> Share
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-3 md:grid-cols-5 gap-2">
        {displayBudget.accommodation && (
          <div className="bg-ocean/10 rounded-lg p-2 text-center border border-ocean/15">
            <p className="text-[10px] text-ocean/70 uppercase tracking-wide">Accommodation</p>
            <p className="font-semibold text-ocean text-sm">{displayBudget.accommodation}</p>
          </div>
        )}
        {displayBudget.food && (
          <div className="bg-ocean/10 rounded-lg p-2 text-center border border-ocean/15">
            <p className="text-[10px] text-ocean/70 uppercase tracking-wide">Food</p>
            <p className="font-semibold text-ocean text-sm">{displayBudget.food}</p>
          </div>
        )}
        {displayBudget.flights && (
          <div className="bg-ocean/10 rounded-lg p-2 text-center border border-ocean/15">
            <p className="text-[10px] text-ocean/70 uppercase tracking-wide">Flights</p>
            <p className="font-semibold text-ocean text-sm">{displayBudget.flights}</p>
          </div>
        )}
        {displayBudget.transport && (
          <div className="bg-ocean/10 rounded-lg p-2 text-center border border-ocean/15">
            <p className="text-[10px] text-ocean/70 uppercase tracking-wide">Transport</p>
            <p className="font-semibold text-ocean text-sm">{displayBudget.transport}</p>
          </div>
        )}
        {displayBudget.activities && (
          <div className="bg-ocean/10 rounded-lg p-2 text-center border border-ocean/15">
            <p className="text-[10px] text-ocean/70 uppercase tracking-wide">Activities</p>
            <p className="font-semibold text-ocean text-sm">{displayBudget.activities}</p>
          </div>
        )}
        {displayBudget.total && (
          <div className="bg-gold/20 rounded-lg p-2 text-center border border-gold/30">
            <p className="text-[10px] text-ocean/60 uppercase tracking-wide font-semibold">Total</p>
            <p className="font-bold text-ocean text-base">{String(displayBudget.total).replace(/\s*\(approx\.?[^)]*\)/gi, '')}</p>
            {displayBudget.currency && (
              <p className="text-[10px] text-ocean/50">{displayBudget.currency}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
